import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { isAuthenticated } from 'containers/App/actions';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import reducer from 'containers/App/reducer';
import saga from 'containers/App/saga';

import Codebook from 'containers/Codebook';

class CodebookDemo extends React.Component {
  componentDidMount() {
    const {
      location,
      checkAuthenticated,
    } = this.props;

    checkAuthenticated(location.pathname);
  }

  render() {
    return (
      <Codebook
        onGenerateCdf={console.log}
      />
    );
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    checkAuthenticated: (path) => {
      dispatch(isAuthenticated(path));
    },
  };
}

const mapStateToProps = createStructuredSelector({
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'home', reducer });
const withSaga = injectSaga({ key: 'home', saga });

CodebookDemo.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  checkAuthenticated: PropTypes.func.isRequired,
};

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(CodebookDemo);



// WEBPACK FOOTER //
// ./app/containers/CodebookDemo/index.js